import { FunctionComponent, ReactNode, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextToiTeaser from '@contexts/toiTeaser'
import { TOITeaserLayoutContextType } from '@contexts/toiTeaser'
import { computeTeaserWidth } from '@widgets/Teaser/utils'
import { ViewportTypeValues } from '@contexts/viewport'
import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'

type StyledLabelProps = Pick<
  TOITeaserLayoutContextType,
  'accentColor' | 'teaserFlex'
>

const { TOITeaserLayoutContext } = contextToiTeaser

const StyledLabel = styled.div<StyledLabelProps>`
  ${({
    theme: {
      fonts: { goodOT: goodOTFontName },
      colors: { white },
    },
    teaserFlex,
    accentColor,
  }) => {
    let fontSizeDesktop
    const desktopTeaserFlex = teaserFlex['desktop']
    const teaserWidthDesktop = computeTeaserWidth({
      flexValue: desktopTeaserFlex,
      viewportType: ViewportTypeValues.DESKTOP,
    })

    if (desktopTeaserFlex === '6') {
      fontSizeDesktop = `${0.02579 * teaserWidthDesktop}px`
    } else if (desktopTeaserFlex === '4') {
      fontSizeDesktop = `${0.03915 * teaserWidthDesktop}px`
    } else if (desktopTeaserFlex === '3') {
      fontSizeDesktop = `${0.04268 * teaserWidthDesktop}px`
    } else if (desktopTeaserFlex === '2') {
      fontSizeDesktop = `${0.04687 * teaserWidthDesktop}px`
    }

    let fontSizeTablet
    const tabletTeaserFlex = teaserFlex['tablet']
    const teaserWidthTablet = computeTeaserWidth({
      flexValue: tabletTeaserFlex,
      viewportType: ViewportTypeValues.TABLET,
    })

    if (tabletTeaserFlex === '6') {
      fontSizeTablet = `${0.04248 * teaserWidthTablet}px`
    } else if (tabletTeaserFlex === '3') {
      fontSizeTablet = `${0.05067 * teaserWidthTablet}px`
    }

    return css`
      font-family: ${goodOTFontName}, 'Arial Narrow', Impact;
      font-weight: 900;
      line-height: normal;
      color: ${white};
      background-color: ${accentColor};
      display: inline-block;
      padding: 2px 6px;
      text-transform: uppercase;
      margin-bottom: 5px;
      ${desktopCSS(css`
        font-size: ${fontSizeDesktop};
      `)}

      ${tabletCSS(css`
        font-size: ${fontSizeTablet};
      `)}

      ${mobileCSS(css`
        font-size: 4.7vw;
      `)}
    `
  }}
`

const Label: FunctionComponent<{ children?: ReactNode }> = ({ children }) => {
  const { accentColor, teaserFlex } = useContext(TOITeaserLayoutContext)

  return (
    <StyledLabel accentColor={accentColor} teaserFlex={teaserFlex}>
      {children}
    </StyledLabel>
  )
}

export default Label
